import { FAQS__MUTATIONS } from "../mutation-types";
import { FAQS__ACTIONS } from "../action-types";
import { FAQS__API } from "@/_helpers/urls";
import http from "@/_helpers/http";
import router from "@/router";

// State
const state = {
  faqs: [],
};

// Mutations
const mutations = {
  [FAQS__MUTATIONS.FAQS](state, data) {
    state.faqs = data;
  },
};

const getters = {};

// Actions
const actions = {
  async [FAQS__ACTIONS.FAQS]({ commit }) {
    try {
      const { data } = await http().get(FAQS__API.FAQS);
      console.log("router", router);
      commit(FAQS__MUTATIONS.FAQS, data?.data?.faqs);
    } catch (error) {
      console.error("Error fetching partner faqs:", error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
